export default __webpack_public_path__ + "static/media/home.5bf35d31.png";